const P = "advancedFilterLibrary.access";
/**
 * Builds the COMPLETE OPAL {@link AccessSettingsLabels} map from the `advancedFilterLibrary.access.*`
 * namespace. The component renders no default text, so an omitted label would show blank.
 *
 * Call inside a `computed` so the labels follow a locale change:
 * `const labels = computed(() => buildAccessSettingsLabels(t));`
 */
export function buildAccessSettingsLabels(t) {
    return {
        generalTitle: t(`${P}.generalTitle`),
        generalDescription: t(`${P}.generalDescription`),
        organizationLabel: t(`${P}.organizationLabel`),
        teamLabel: t(`${P}.teamLabel`),
        teamUnavailableTooltip: t(`${P}.teamUnavailableTooltip`),
        levels: {
            edit: t(`${P}.levels.edit`),
            view: t(`${P}.levels.view`),
            none: t(`${P}.levels.none`),
        },
        peopleTitle: t(`${P}.peopleTitle`),
        peopleDescription: t(`${P}.peopleDescription`),
        groupingHint: t(`${P}.groupingHint`),
        rulePeopleLabel: t(`${P}.rulePeopleLabel`),
        ruleLevelLabel: t(`${P}.ruleLevelLabel`),
        ruleGroupLabel: (position) => t(`${P}.ruleGroupLabel`, { position }),
        addRule: t(`${P}.addRule`),
        removeRule: t(`${P}.removeRule`),
        pickerPlaceholder: t(`${P}.picker.placeholder`),
        pickerConfirm: t(`${P}.picker.confirm`),
        pickerSearchPlaceholder: t(`${P}.picker.searchPlaceholder`),
        pickerSelectAll: t(`${P}.picker.selectAll`),
        pickerClearAll: t(`${P}.picker.clearAll`),
        pickerEmpty: t(`${P}.picker.empty`),
        pickerLoading: t(`${P}.picker.loading`),
        removeUser: (name) => t(`${P}.removeUser`, { name }),
        inactiveUser: (name) => t(`${P}.inactiveUser`, { name }),
        alreadyInOtherRule: t(`${P}.alreadyInOtherRule`),
        viewWithoutEffect: t(`${P}.viewWithoutEffect`),
        peopleWithoutEffect: t(`${P}.peopleWithoutEffect`),
    };
}
